function initMainNavDropdown() {
    const navButton = document.querySelector(".main-nav__button-container");
    if (!navButton || navButton.dataset.dropdownInitialized === "true") return;

    // Set up dropdown using functionality from vb_dropdown_menu.js
    setUpDropdown(".main-nav__button-container", ".main-nav__body");
    navButton.dataset.dropdownInitialized = "true";
}

document.addEventListener("DOMContentLoaded", initMainNavDropdown);
document.addEventListener("turbolinks:load", initMainNavDropdown);
